import { z } from 'zod'

// 해외
export const overseasPriorityFormSchema = z.object({
  warehouseCodes: z.array(z.string().optional()).refine((data) => data.some(Boolean)),
})

// 국내
export const allocationPriorityFormSchema = z
  .object({
    packingWarehouseCodes: z.array(z.string().optional()).optional(),
    warehousePriorityWarehouseCodes: z.array(z.string().optional()).optional(),
    allocationStrategy: z.enum(['PACKING', 'WAREHOUSE_PRIORITY']),
    usePriority: z.boolean().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.allocationStrategy === 'PACKING' && data.usePriority === true) {
      const packingCodes = data.packingWarehouseCodes || []
      const isEmpty = !packingCodes.length
      const isNotSelected = !packingCodes.some(Boolean)

      if (isEmpty || isNotSelected) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['packingWarehouseCodes'],
        })
      }
    }

    if (data.allocationStrategy === 'WAREHOUSE_PRIORITY') {
      const warehousePriorityCodes = data.warehousePriorityWarehouseCodes || []
      const isEmpty = !warehousePriorityCodes.length
      const isNotSelected = !warehousePriorityCodes.some(Boolean)

      if (isEmpty || isNotSelected) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['warehousePriorityWarehouseCodes'],
        })
      }
    }
  })

export type OverseasPriorityForm = z.infer<typeof overseasPriorityFormSchema>
export type AllocationPriorityForm = z.infer<typeof allocationPriorityFormSchema>
